import { setCookie } from "../functions/cookie";
import { calculateHeaderSize } from "../functions/window";

const cookieMessage = document.querySelector(".js-cookie-message");
const infoMessages = document.querySelectorAll(".js-info-message");

if (cookieMessage) {
    cookieMessage.classList.add("is-loaded");

    cookieMessage.querySelector(".js-cookie-message-close").addEventListener("click", (event) => {
        event.preventDefault();

        setCookie("cookies-allowed", 1, 365);

        cookieMessage.classList.remove("is-loaded");
    });
}

if (infoMessages) {
    infoMessages.forEach((infoMessage) => {
        const closeBtn = infoMessage.querySelector(".js-info-message-close");

        if (closeBtn) {
            closeBtn.addEventListener("click", (event) => {
                event.preventDefault();

                const cookieKey = infoMessage.dataset.cookieKey;
                const cookieValue = infoMessage.dataset.cookieValue;

                setCookie(cookieKey, cookieValue, 1);

                infoMessage.style.display = "none";

                requestAnimationFrame(calculateHeaderSize);
            });
        }
    });
}
